import { authDebugError } from "./safeAuthLog";

/**
 * Session-scoped state that must not outlive a logout (MDRS-486).
 *
 * Some of that state lives outside the auth layer — the React Query cache,
 * pop-out windows rendering case content — and the logout paths
 * (`tokenManager.logoutUser`, `useAuth().logout`) can't import it directly:
 * `reactQueryClient` already imports `tokenManager`, so the reverse import
 * would be circular. Owners subscribe here instead and logout runs them.
 */
type SessionEndCallback = () => void;

const callbacks = new Set<SessionEndCallback>();

/** Subscribe to logout. Returns an unsubscribe function. */
export const onSessionEnd = (callback: SessionEndCallback) => {
  callbacks.add(callback);
  return () => {
    callbacks.delete(callback);
  };
};

/** Run every subscriber. One failing callback never blocks the others. */
export const runSessionTeardown = () => {
  callbacks.forEach((callback) => {
    try {
      callback();
    } catch (error) {
      authDebugError("sessionTeardown: callback failed", error);
    }
  });
};
